import React from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
} from 'reactstrap';

import AdminCustomFieldEditMainEdit from './MainEdit';
import AdminCustomFieldEditSettings from './Settings';
import AdminCustomFieldEditMetadataGroups from './MetadataGroups';

const AdminCustomFieldEditTabContent = ({ activeTab, ...props }) => (
  <TabContent activeTab={activeTab} className="settings-tab-content custom-field-edit">
    <TabPane tabId="details">
      <AdminCustomFieldEditMainEdit
        {...props}
      />
    </TabPane>
    <TabPane tabId="settings">
      <AdminCustomFieldEditSettings
        {...props}
        entity={props.customField}
        entityId={props.customFieldId}
      />
    </TabPane>
    <TabPane tabId="metadata-groups">
      <AdminCustomFieldEditMetadataGroups
        {...props}
        entity={props.customField}
        entityId={props.customFieldId}
      />
    </TabPane>
  </TabContent>
);

AdminCustomFieldEditTabContent.propTypes = {
  customField: PropTypes.object,
  customFieldId: PropTypes.string,
  activeTab: PropTypes.string.isRequired,
};

AdminCustomFieldEditTabContent.defaultProps = {
  customField: null,
  customFieldId: null,
};

export default AdminCustomFieldEditTabContent;
